import styled, { css } from 'styled-components';
import ReactSlider from 'react-slider';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 10px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.span`
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  position: relative;
  display: block;
`;

export const StyledSlider = styled(ReactSlider)`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Thumb = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brand.rideOctaneBlue};
  border-radius: 100%;
  position: relative;
  overflow: hidden;
  &:focus-visible {
    outline: none;
  }
`;

export const Track = styled.div`
  height: 12px;
  background-color: ${({ theme }) => theme.colors.monochrome.smoke};
  border-radius: 5px;
  ${({ activeTrack, theme }) =>
    activeTrack &&
    css`
      background-color: ${theme.colors.brand.rideOctaneBlue};
    `}
`;
